var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinCampra22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 9.5C22.625 11.6509 21.3993 14.5551 19.7467 17.3673C18.1038 20.1628 16.0824 22.7957 14.575 24.3851C14.5329 24.4296 14.4671 24.4296 14.425 24.3851C12.9176 22.7957 10.8962 20.1628 9.25334 17.3673C7.60069 14.5551 6.375 11.6509 6.375 9.5C6.375 5.01269 10.0127 1.375 14.5 1.375C18.9873 1.375 22.625 5.01269 22.625 9.5Z",
    fill: "#049587",
    stroke: "#04645A",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCampra22);
export default __webpack_public_path__ + "static/media/pin_campra22.709b8007d94247dfa92c92f4e85d84f7.svg";
export { ForwardRef as ReactComponent };